import React from 'react';
import { FormattedMessage } from '@kyruus/intl';
import ScheduleIcon from '@kyruus/react-ikons/Schedule';

import { AvailableWithinDaysText } from './styles';
import messages from '../../lib/messages';

interface AvailableWithinDaysProps {
  availabilityDensityBest: string;
}

const AvailableWithinDays = ({
  availabilityDensityBest
}: AvailableWithinDaysProps): React.ReactElement => {
  return (
    <AvailableWithinDaysText data-testid="profile-available-within-days">
      <ScheduleIcon size="16px" aria-hidden={true} />
      <FormattedMessage
        {...messages.availability}
        values={{
          days: availabilityDensityBest
        }}
      />
      *
    </AvailableWithinDaysText>
  );
};

export default AvailableWithinDays;
